export default __webpack_public_path__ + "static/media/fbas-logo.01b8572d.svg";